export default __webpack_public_path__ + "static/FAIRY_BREAD_SPRINKLES-74e927d1ea46310117f695b08bf37979.png";